import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class PlanSiteService {

  constructor(private http:HttpClient,private global:Global) { }
  httpOptions = {
    headers: new HttpHeaders({
      "accept": "application/json;odata=Nometadata",
      "content-type": "application/json;odata=verbose"
    })
  };
  getAllMenu( lg) {
    const url =   lg +"/_api/web/lists/GetByTitle('Menu')/items?$select=*&$top=1000"
  return this.http.get(url ,this.httpOptions);
}

}
